import { connect } from 'react-redux';

import {
  sendFriendsRequest,
  setSendFriendRequestMessage,
  setSendFriendRequestSuccess,
} from '../../actions/MyFriendsActions';
import {
  getSendFriendsRequestMessage,
  getSendFriendsRequestSuccess,
  getSendFriendsRequestWaiting,
} from '../../components/AccountSettings/MyFriends/MyFriendsSelectors';
import InviteAFriendView from '../../components/Dashboard/InviteAFriend/inviteAFriendView.jsx';

const mapStateToProps = (state, ownProps) => ({
  sendFriendsRequestWaiting: getSendFriendsRequestWaiting(state),
  sendFriendsRequestSuccess: getSendFriendsRequestSuccess(state),
  sendFriendsRequestMessage: getSendFriendsRequestMessage(state),
});
const mapDispatchToProps = (dispatch) => ({
  sendFriendsRequest: (email) => dispatch(sendFriendsRequest(email)),
  setSendFriendRequestSuccess: (value) =>
    dispatch(setSendFriendRequestSuccess(value)),
  setSendFriendRequestMessage: (message) =>
    dispatch(setSendFriendRequestMessage(message)),
});

const InviteAFriendContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(InviteAFriendView);

export default InviteAFriendContainer;
